import type { ExtendedPartTagType } from '@/entities/rubrics';

const SpecialTags = {
  ALL: 'all',
  GROUP: 'group',
  NEOBYICHNYIE_MARSHRUTYI: 'neobyichnyie-marshrutyi',
  NEW: 'novye',
  SPECIAL_OFFERS: 'special_offers',
};

export const specialTagsSlugs = Object.values(SpecialTags);

export const SpecialTagsOrder = {
  [SpecialTags.ALL]: 1,
  [SpecialTags.NEOBYICHNYIE_MARSHRUTYI]: 3,
  [SpecialTags.NEW]: 4,
  [SpecialTags.SPECIAL_OFFERS]: 2,
  default: 0,
};

export const moreValue = 'more';
export const allValue = 'all';

export const DEFAULT_RUBRIC: ExtendedPartTagType = { value: 'all', label: 'Все', is_tours_included: false };

export const RUBRICS_SKELETON_WIDTH_FIRST = [80, 112, 164, 120, 100, 160, 80, 136, 120];
export const RUBRICS_SKELETON_WIDTH_SECOND = [116, 144, 104, 88, 120, 108, 54];
